<div class="create-photo-report__categories-images-current">
  @if (!isImageLoading()) {
    <img
      (click)="onRotateClick()"
      class="create-photo-report__categories-images-current-turn"
      [class.disabled]="isLoading"
      src="assets/images/icons-svg/turn-photo-arrow.svg"
    />
  }
  <img
    [src]="getImageSrc() | addBaseUrl"
    [class.loading]="isImageLoading()"
    [style.transform]="'rotate(' + getRotateAngle() + 'deg)'"
    draggable="false"
    class="create-photo-report__categories-images-current-image"
  />
  <img
    class="create-photo-report__categories-images-current-delete"
    [class.disabled]="isLoading"
    src="assets/images/icons-svg/delete-icon-black.svg"
    (click)="onDeleteClick()"
  />
  @if (isImageLoading()) {
    <div class="spinner">
      <ion-spinner name="circles"></ion-spinner>
    </div>
  }
</div>
